import React from 'react'
import './Footer.css'
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
const Footer = () => {
    return (
        <div>
            <div className="bt_bb_wrapper" style={{ marginTop: "" }}>
                <section
                    id="bt_section66277d7b2166f"
                    data-parallax="0.7"
                    data-parallax-offset="0"
                    className="boldSection topSpaced bottomSemiSpaced btDarkSkin gutter boxed inherit btParallax wBackground cover wBackground cover"
                    style={{
                        backgroundColor: "black",
                        backgroundImage: `url("https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/10/background-footer-light-blue.jpg")`,
                        backgroundPosition: "50% -18.4104px",
                        marginBottom: "-50px"
                    }}
                >
                    <div className="port" style={{ marginTop: "-80px" }}>
                        <div className="boldCell">
                            <div className="boldCellInner">
                                <div className="boldRow ">
                                    <div className="boldRowInner">
                                        <div className="rowItem col-md-3 col-sm-6 col-ms-12" data-width="3">
                                            <div className="rowItemContent">
                                                <header className="header btClear small btDash bottomDash">
                                                    <div className="btSuperTitle"><span></span></div>
                                                    <div className="dash">
                                                        <h4 style={{ fontSize: "30px" }}>
                                                            <span className="headline">AUTOMET ENGINEERING</span>
                                                        </h4>
                                                    </div>
                                                    <div className="btSubTitle" style={{ fontSize: "18px" }} >
                                                        Garudachar Palya, Mahadevapura, Bengaluru,  Karnataka 560048
                                                    </div>
                                                </header>
                                                <span className="btIco btIcoDefaultType btIcoSmallSize btIcoDefaultColor ">
                                                    <a href="#" target="no_target" class="fa fa-mobile-alt">
                                                        <span style={{ marginLeft: "10px" }}>+91 ⁠9845164986 
                                                        </span>
                                                       
                                                    </a>
                                                    <a href="#" target="no_target" class="fa fa-mobile-alt">
                                                        <span style={{ marginLeft: "10px" }}>+91 9980411999  
                                                        </span>
                                                       
                                                    </a>
                                                </span>
                                                <div className="btClear btSeparator noBorder"><hr /></div>
                                                <span className="btIco btIcoDefaultType btIcoSmallSize btIcoDefaultColor ">

                                                </span>
                                                <div className="btClear btSeparator noBorder"><hr /></div>
                                                <span className="btIco btIcoDefaultType btIcoSmallSize btIcoDefaultColor " style={{ marginTop: "-30px" }}>
                                                    <a href="mailto:autometengg2@gmail.com" target="_self" className="fa fa-envelope">
                                                        <span style={{ marginLeft: "10px" }}>autometengg2@gmail.com</span>
                                                    </a>

                                                </span>
                                                <div className="btClear btSeparator bottomSemiSpaced noBorder"><hr /></div>
                                            </div>
                                        </div>

                                        <div className="rowItem col-md-3 col-sm-6 col-ms-12 " data-width="3" >
                                            <div className="rowItemContent">
                                                <header className="header btClear small btDash bottomDash">
                                                    <div className="btSuperTitle" style={{ fontSize: "30px" }}><span>GET IN TOUCH</span></div>
                                                    <div className="dash">
                                                        <h4>
                                                            <span className="headline" style={{ fontSize: "18px" }} >Follow Our Activity</span>
                                                        </h4>
                                                    </div>
                                                    <div className="btSubTitle" style={{ fontSize: "20px" }} >
                                                    Stay connected and never miss out on our latest updates,  and special offers by following us on our social media channels!
                                                    </div>
                                                </header>
                                                <div className="btClear btSeparator bottomSmallSpaced noBorder"><hr /></div>
                                                <span className="btIco btIcoFilledType btIcoMediumSize btIcoAccentColor btIconCircleShape btIcoHolder">


                                                    <div className="btIcoHolder" style={{ fontSize: "40px" }} >
                                                        <FaFacebook />
                                                    </div>
                                                </span>
                                                <span className="btIco btIcoFilledType btIcoMediumSize btIcoAccentColor btIconCircleShape">
                                                    <div className="btIcoHolder" style={{ fontSize: "40px" }} >
                                                        <FaInstagram />
                                                    </div>
                                                </span>
                                                <span className="btIco btIcoFilledType btIcoMediumSize btIcoAccentColor btIconCircleShape">
                                                    <div className="btIcoHolder" style={{ fontSize: "40px" }} >
                                                        <FaYoutube />
                                                    </div>
                                                </span>
                                                <div className="btClear btSeparator bottomSemiSpaced noBorder"><hr /></div>
                                            </div>
                                        </div>
                                        <div className="rowItem col-md-3 col-sm-6 col-ms-12 responsive_google_map" data-width="3" >
                                            <div className="elementor-custom-embed responsive_google_map" >
                                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15551.005205702344!2d77.701766!3d12.9877523!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae119db64c2f21%3A0xfadda48ebb35fe09!2sAutomet!5e0!3m2!1sen!2sin!4v1713333882038!5m2!1sen!2sin" className="map" style={{ border: "0", width: "600px", height: "360px" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            <footer class="footer">
                <div class="container">
                    <div class="footer-content">
                        <div class="footer-column">
                            <p >&copy; 2024 Automet Engineering. All rights reserved.</p>
                        </div>
                        <div class="footer-column">
                            <p >
                                <a href="https://www.excerptech.com" target="_blank" rel="noopener noreferrer">&copy; Designed By EXCERPT TECHNOLOGIES PVT.LTD</a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

        </div>
    )
}

export default Footer